import styled from "styled-components";

export const DividerContainer = styled.div`
	width: 100%;
	height: 1px;
	margin: 0.5rem 0;
	border-bottom: 1px solid #333;
`;
